import { TooltipHover } from "components/designV2/tooltip/tooltip";
import type { StaffWorkGroup } from "services/api/company/staff.service";
import { formatWorkerTeamLabels } from "./workerTeamLabel.logic";
import {
  ExtraCount,
  PrimaryLabel,
  Summary,
  TooltipAligner,
  TooltipItem,
  TooltipList,
} from "./workerTeamSummary.styled";

interface WorkerTeamSummaryProps {
  readonly emptyLabel: string;
  readonly workGroups?: readonly StaffWorkGroup[];
}

export const WorkerTeamSummary = ({
  emptyLabel,
  workGroups,
}: WorkerTeamSummaryProps): JSX.Element => {
  const labels = formatWorkerTeamLabels(workGroups);
  const primaryLabel = labels[0] ?? emptyLabel;
  const remainingLabels = labels.slice(1);

  return (
    <Summary>
      <PrimaryLabel>{primaryLabel}</PrimaryLabel>
      {remainingLabels.length > 0 && (
        <TooltipAligner>
          <TooltipHover
            content={
              <TooltipList>
                {remainingLabels.map((label, labelIndex) => (
                  <TooltipItem key={`${label}-${labelIndex}`}>
                    {label}
                  </TooltipItem>
                ))}
              </TooltipList>
            }
            arrow="down"
            textAlign="left"
            minWidth={230}
            maxWidth={330}
          >
            <ExtraCount>+{remainingLabels.length}</ExtraCount>
          </TooltipHover>
        </TooltipAligner>
      )}
    </Summary>
  );
};
